import React, { useContext, useEffect, useMemo, useState } from 'react';

// Styles & Assets
import styles from './CalendarFilterDialog.module.css';
import { ReactComponent as FilterSVG } from '../../../assets/icons/filter-off-fill.svg';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';
import { getFullName } from '../../../services/getPatientAtribute';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Context
import FiltersContext from '../../../context/FiltersContext';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import MultiSelectButtons from '../../Helpers/MultiSelectButtons/MultiSelectButtons';

// Interfaces
import { Patient } from '../../../interfaces/Patient';
import PatientsCheckbox from '../../Helpers/PatientsCheckbox/PatientsCheckbox';
interface PatientOptions {
    id: Patient['id']
    name: string,
    profile_id: number | null
}
interface Props {
    modalShow: React.Dispatch<React.SetStateAction<boolean>>
}

const CalendarFilterDialog: React.FC<Props> = ({ modalShow }) => {

    const { t } = useTranslation();

    const filtersContext = useContext(FiltersContext);

    const [patients, setPatients] = useState<PatientOptions[]>([]);

    const { sendRequest } = useHttp<Patient[]>();

    useEffect(() => {
        sendRequest({
            url: getEnvironmentApiUrl() + 'patient/hospital_list',
            method: 'POST',
            body: {
                params: {},
                filter: {},
            }
        }, (data) => {
            setPatients(data.map(p => ({
                id: p.id,
                name: getFullName(p),
                profile_id: p.cases[0]?.follow_ups?.[0]?.profile?.id ?? null
            })))
        })
    }, [sendRequest]);

    const [selectedProfiles, setSelectedProfiles] = useState<number[]>([]);
    const [checkedPatients, setCheckedPatients] = useState<number[]>([]);

    const profiles = useMemo(() => filtersContext.profiles.map(p => {
        return { id: p.id, content: p.name ?? '' };
    }), [filtersContext.profiles]);

    const handleSelectProfile = (id: number) => {
        setSelectedProfiles(oldProfiles => oldProfiles.includes(id) ?
            oldProfiles.filter(pID => pID !== id) :
            [...oldProfiles, id]
        )
    };

    const handleRemoveFilters = () => {
        setSelectedProfiles([]);
        setCheckedPatients([]);
    }

    const patientsFiltered = selectedProfiles.length === 0 ? patients : patients.filter(p => selectedProfiles.some(profileID => profileID === p.profile_id));

    return (
        <div className='dialog'>
            <div className={styles.topBar}>
                <div>
                    <h1 className='dialogTitle'>
                        {t('filter')}
                    </h1>
                    <h2 className='dialogSubTitle'>
                        {t('calendar')}
                    </h2>
                </div>
                <button className={`button ${styles.buttonRemove}`} onClick={handleRemoveFilters}>
                    {t('remove_filters')}
                    <FilterSVG />
                </button>
            </div>
            <h3 className={styles.categoryTitle}>{t('environment')}</h3>
            <div className={styles.buttonsEnvironmentContainer}>
                <MultiSelectButtons
                    selectedIDs={selectedProfiles}
                    onClick={handleSelectProfile}
                    content={profiles}
                />
            </div>
            <h3 className={styles.categoryTitle}>{t('patients_with_appointment')}</h3>
            <PatientsCheckbox patients={patientsFiltered} checkedPatients={checkedPatients} setCheckedPatients={setCheckedPatients} />
            <CancelConfirmButtons
                onCancel={() => {/* */ }}
                onConfirm={() => {/* */ }}
            />
        </div>
    );
};

export default CalendarFilterDialog;